module.exports = __webpack_public_path__ + "static/use-case-3-content-3-3a0e27a5a008a05793f19dd7d9afc953.png";